const mappingsTable = require("@/utils/dataMap");
const mappingsTools = require("@/utils/mapTools");
const modalUtils = require("./modalUtils");
const mixinTable = require("./table"); // 表格的混入
const timeStandrd = require("@/utils/moment");

module.exports = {
  mixins: [mixinTable, modalUtils],
  data() {
    return {
      expandedRow: [],
    };
  },
  methods: {
    // 处理数据中存在需要转换的值
    handlerResultMappings(result) {
      const v = result || [];
      mappingsTools.dealResult2Map(v, mappingsTable.v2Label);
      console.log(v);
    },
    // 处理日期格式
    handlerDateFormat(list) {
      list.forEach((item) => {
        // 处理时间格式，覆盖原始接口返回的参数
        item.createTime = timeStandrd.timeStandrd(item.createTime);
        item.publishTime = timeStandrd.timeStandrd(item.publishTime);
        item.updateTime = timeStandrd.timeStandrd(item.updateTime);
      });
      return list;
    },
    //递归处理
    handlerDateFormatRecursion(list) {
      list.forEach((item) => {
        // 处理时间格式，覆盖原始接口返回的参数
        item.createTime = timeStandrd.timeStandrd(item.createTime);
        item.publishTime = timeStandrd.timeStandrd(item.publishTime);
        item.updateTime = timeStandrd.timeStandrd(item.updateTime);
        item.key = item.id;
        item.value = item.id;
        item.title = item.label;
        if (item.children && item.children.length) {
          this.expandedRow.push(item.id);
          this.handlerDateFormatRecursion(item.children);
        }
      });
      return list;
    },
  },
};
